import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionStorageService } from '../../shared/session/session-storage/session-storage.service';
import { MortgageSessionDataModel } from '../models/mortgage-session-data.model';

@Injectable()
export class MortgageSessionService {

  // Data that is not saved to session storage
  public isCarouselLead: boolean = false;
  public isLoanOfficerReference: boolean = false;

  // Data that is saved to session storage
  public set data(value: MortgageSessionDataModel) {
    this._data = value;
    this._data.setSessionData(value);
  }
  public get data(): MortgageSessionDataModel {
    return this._data;
  }

  constructor(private _data: MortgageSessionDataModel) {
    const existingSession = this.data.getSessionData();
    if (!existingSession) {
      this.data = _data;
    } else {
      this.data.populate(existingSession);
    }
  }

  public saveMortgageSessionData(): void {
    this.data.setSessionData(this.data);
  }

  public resetHydrationData(): void {
    SessionStorageService.deleteHydrationKeys();
  }

  public resetLoanApplication(): void {
    this.data.clear();
    // per Brian May, borrowerData.clear should be unnecessary,
    // as its only concern should be resetting the SessionStorage data,
    // which the above data.clear() should already handle.
    // however, there is currently no better place to put logic for
    // propagating the isInSpousalCoBorrowerFlowChange event,
    // which should be fired any time the data is cleared, so it will stay here for now
    this.data.borrowerData.clear();
    this.isLoanOfficerReference = false;
  }
}
